import Navbar from "./components/NavBar/Navbar";
import Home from "./pages/Home";
import "./global_styles/main.scss";

function App() {
  return (
    <>
      <Navbar />
      <Home />
    </>
  );
}

export default App;
